export default __webpack_public_path__ + "static/car-f5f41609ff7105ffb28cc450b6b05f7c.png";